<template>
  <div class="w-100" style="padding:15px">

    <template v-if="delivery_gps_data.show_map">
      <gmap-map :center="center" :zoom="zoom" class="gmap">
        <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :icon="m.icon"
            @click="center=m.position"
        ></gmap-marker>
      </gmap-map>
    </template>

    <template v-if="delivery_gps_data.delivery_status < 200 || delivery_gps_data.delivery_status === 500">
      <h3>No delivery in progress</h3>
    </template>

    <div class="form-group col-md-12 col-sm-12 col-xs-12 order-status">

      <template v-if="delivery_gps_data.show_special_text">
        {{delivery_gps_data.special_text}}
        <br>
      </template>

      <template v-if="delivery_gps_data.delivery_status >= 200 && delivery_gps_data.delivery_status < 500">
        <br>
        <template v-if="delivery_gps_data.status_text">
          {{delivery_gps_data.status_text}}
          <br>
        </template>

        <template v-if="delivery_gps_data.delivery_time_string">
          <br>
          {{delivery_gps_data.delivery_time_string}}
          <br>
          <br>
        </template>

        <template v-if="delivery_gps_data.delivery_address.address1">
          Order# {{delivery_gps_data.ordernumber}} for
          <br>
          {{delivery_gps_data.delivery_address.firstname}} {{delivery_gps_data.delivery_address.lastname}}
          <br>
          {{delivery_gps_data.delivery_address.address1}}
          <br>
          {{delivery_gps_data.delivery_address.city}}, {{delivery_gps_data.delivery_address.state}} {{delivery_gps_data.delivery_address.zip}}
          <br>
        </template>



<!--        <template v-if="!hideCancelBlock">-->
<!--          <div class="message_label">-->
<!--            Request order cancellation-->
<!--          </div>-->
<!--          <div>-->
<!--              <input-->
<!--                  class="reason_text"-->
<!--                  type="text"-->
<!--                  id="reason_text"-->
<!--                  v-model="reason_text"-->
<!--                  placeholder=""-->
<!--                  name="reason_text"-->
<!--              />-->
<!--            <button @click="sendCancelRequest">Cancel</button>-->
<!--          </div>-->
<!--        </template>-->


<!--        <template v-if="cancel_request_response.response_text">-->
<!--          <div class = "message_label">-->
<!--            {{ cancel_request_response.response_text }}-->
<!--          </div>-->
<!--        </template>-->




<!--        <template v-if="signedIn">-->
<!--          <br>-->
<!--          <template v-if="!hideMessageButton">-->
<!--            <div class="message_label">-->
<!--              Send a message to the Unibud team-->
<!--            </div>-->
<!--            <div>-->
<!--                <input-->
<!--                    class="message_input"-->
<!--                    type="text"-->
<!--                    id="customer_message"-->
<!--                    v-model="customer_message"-->
<!--                    placeholder=""-->
<!--                    name="customer_message"-->
<!--                />-->
<!--                <button class="button" @click="sendCustomerMessage()">Send</button>-->
<!--            </div>-->
<!--          </template>-->
<!--          <template v-else>-->
<!--            <div class = "message_label">-->
<!--            Message sent: We will contact you soon!-->
<!--            </div>-->
<!--          </template>-->
<!--        </template>-->



      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "GoogleMap",
  computed: {
    ...mapGetters({
      delivery_gps_data: "cart/delivery_gps_data",
      customer_message_response: "cart/customer_message_response",
      signedIn: 'auth/signedIn',
      cancel_request_response: 'cart/cancel_request_response',
    })
  },
  data() {
    return {
      center: { lat: 34.20, lng: -118.50 },
      zoom: 10,
      markers: [],
      updateTimer: null,
      markerTimer: null,
      hideMessageButton: false,
      customer_message: '',
      reason_text: '',
      hideCancelBlock: true,
    };
  },
  created() {
    this.startAutoUpdateTimer();
    this.startMarkerTimer();
    this.update_delivery_gps();
  },
  beforeDestroy () {
    clearInterval(this.updateTimer);
    clearInterval(this.markerTimer);
  },
  watch: {
    cancel_request_response: function () {
      this.update_delivery_gps();
    },
    delivery_gps_data: function () {
      this.hideCancelBlock = false;
      if(this.delivery_gps_data.delivery_status === 280) {
        this.hideCancelBlock = true;
      }
      if(this.delivery_gps_data.cancelrequest === 1) {
        this.hideCancelBlock = true;
      }
      if(this.delivery_gps_data.allow_cancel === 0) {
        this.hideCancelBlock = true;
      }
    },
  },
  methods: {
    sendCustomerMessage() {
      if(this.customer_message.length > 0) {
        this.hideMessageButton = true;
        this.$store.dispatch('cart/sendCustomerMessage', {message: this.customer_message});
        this.customer_message = '';
      }
    },
    sendCancelRequest() {
      this.hideCancelBlock = true;
      this.$store.dispatch('cart/sendCancelRequest', {reason_text: this.reason_text, orderid: this.delivery_gps_data.orderid});
      this.reason_text = '';
    },
    update_delivery_gps() {
      this.$store.dispatch('cart/updateDeliveryGPS')
    },
    startAutoUpdateTimer: function () {
      this.updateTimer = setInterval(function () {
        this.update_delivery_gps();
      }.bind(this), 15000);
    },
    startMarkerTimer: function () {
      this.markerTimer = setInterval(function () {
        this.addMarkers();
      }.bind(this), 4500);
    },
    addMarkers() {

        this.markers = [];

      // https://developers.google.com/maps/documentation/javascript/markers#maps_icon_simple-typescript
      // https://developers.google.com/maps/documentation/javascript/examples/marker-modern  SVG
      // "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"
      // https://codinginfinite.com/realtime-moving-cars-google-maps-javascript-firebase/

      this.zoom = 11;

      if (this.delivery_gps_data.delivery_latitude > 20) {
        const delivery_marker = {
          lat: this.delivery_gps_data.delivery_latitude,
          lng: this.delivery_gps_data.delivery_longitude
        };
        this.zoom = 16;
        this.center = delivery_marker;
        this.markers.push({position: delivery_marker});

        if (this.delivery_gps_data.car_latitude > 20) {

          var car_icon = { // car icon
            path: 'M29.395,0H17.636c-3.117,0-5.643,3.467-5.643,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759   c3.116,0,5.644-2.527,5.644-5.644V6.584C35.037,3.467,32.511,0,29.395,0z M34.05,14.188v11.665l-2.729,0.351v-4.806L34.05,14.188z    M32.618,10.773c-1.016,3.9-2.219,8.51-2.219,8.51H16.631l-2.222-8.51C14.41,10.773,23.293,7.755,32.618,10.773z M15.741,21.713   v4.492l-2.73-0.349V14.502L15.741,21.713z M13.011,37.938V27.579l2.73,0.343v8.196L13.011,37.938z M14.568,40.882l2.218-3.336   h13.771l2.219,3.336H14.568z M31.321,35.805v-7.872l2.729-0.355v10.048L31.321,35.805',
            scale: 0.67,
            fillColor: "#006700",
            fillOpacity: 1,
            strokeWeight: 1,
            rotation: this.delivery_gps_data.car_heading,
            labelOrigin: {x: 0, y: +10},
            anchor: new google.maps.Point(24, 25), // 0.67
          };

          const car_marker = {
            lat: this.delivery_gps_data.car_latitude,
            lng: this.delivery_gps_data.car_longitude
          };
          this.center = car_marker;
          this.zoom = 13;
          this.markers.push({ position: car_marker,  icon :  car_icon});
        }
      }

      this.currentPlace = null;

    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    }
  }
};
</script>


<style scoped>

.button {
  width: 90px;
  padding: 8px;
  color: #fff ;
  background-color: #033D02;
  border: none;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}

.message_input {
  width: calc(100% - 110px);
  padding: 5px;
  margin: 10px;
  text-align: left;
  border-radius: 4px;
}

.message_label {
  text-align: center;
  padding: 0;
  margin: 0;
  color: black;
}

</style>
